import { put, call, all, takeLatest } from "redux-saga/effects";
import { axiosPost, setUser, clearUser, axiosGet } from "../util/axios";
import { login } from "../util/routers";
import { HTTP_SUCCESS_STATUSES } from "../constants/http_constants";
import * as actionType from "../constants/action_types";
import * as actions from "../actions/index";

function* authorize(action) {
  try {
    let { data, status } = yield call(axiosPost, login, action.payload);
    if (!HTTP_SUCCESS_STATUSES.includes(status))
      throw new Error(data?.message || data);
    else {
      yield put(
        actions.SAVE_TO_LOCAL([
          ["user", JSON.stringify(data.data.user)],
          ["token", data.data.token],
        ])
      );
      // Default header set
      setUser();

      const url = `master/region`;
      let { data: region } = yield call(axiosGet, url, action.payload);
      if (region?.data?.length > 0) {
        yield put(
          actions.SAVE_TO_LOCAL([
            ["region_code", region.data[0].dc_name],
            ["regions", JSON.stringify(region.data)],
          ])
        );
      }
      yield put(
        actions.LOGIN_SUCCESS({ ...data.data.user, token: data.data.token })
      );
    }
  } catch (error) {
    yield put(actions.STOP_LOADER);
    yield put(actions.LOGIN_ERROR(error));
  }
}

function* logout(action) {
  yield put(actions.CLEAR_FROM_LOCAL(["user", "token",/^dt_params_.*/g]));
  clearUser();
  yield put(actions.STOP_LOADER);
  yield put(actions.LOGOUT_SUCCESS({}));
}

function* authWatcherSaga() {
  yield all([
    takeLatest(actionType.LOGIN_REQ, authorize),
    takeLatest(actionType.LOGOUT_REQ, logout),
  ]);
}
export default authWatcherSaga;
